import React, { useState } from 'react';
import {
  Box,
  Button,
  Typography,
  TextField,
  Alert,
  CircularProgress,
} from '@mui/material';
import { OtpCodeInputProps } from '../types';

const OtpCodeInput: React.FC<OtpCodeInputProps> = ({
  onVerify,
  onResend,
  isLoading,
  attemptsRemaining,
  error,
}) => {
  const [code, setCode] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (code.length === 6) {
      onVerify(code);
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit}>
      <Typography variant="h5" gutterBottom>
        Enter Verification Code
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        We sent a 6-digit code to your selected contact method.
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <TextField
        label="Verification Code"
        value={code}
        onChange={(e) => {
          const val = e.target.value.replace(/\D/g, '').slice(0, 6);
          setCode(val);
        }}
        inputProps={{ maxLength: 6, inputMode: 'numeric', pattern: '[0-9]*' }}
        fullWidth
        autoFocus
        sx={{ mb: 2 }}
      />

      {attemptsRemaining !== null && (
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ mb: 2, display: 'block' }}
        >
          {attemptsRemaining} attempt{attemptsRemaining !== 1 ? 's' : ''}{' '}
          remaining
        </Typography>
      )}

      <Button
        type="submit"
        variant="contained"
        color="primary"
        disabled={code.length !== 6 || isLoading}
        fullWidth
        sx={{ mb: 1 }}
      >
        {isLoading ? <CircularProgress size={24} /> : 'Verify'}
      </Button>

      <Button
        variant="text"
        size="small"
        onClick={onResend}
        disabled={isLoading}
        sx={{ mt: 1 }}
      >
        Resend Code
      </Button>
    </Box>
  );
};

export default React.memo(OtpCodeInput);
